import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DataTable from "./components/DataTable";
import { Icon } from "@iconify/react";
import { useAuthInfo } from "../../../../context/auth";
import { useAppServices } from "../../../../hook/services";
import env from "../../../../config";
import UpgradeplanModal from "./components/UpgradeplanModal";
import LoadingScreen from "../../../../components/LoadingScreen";
const Accounts = () => {
  const AppService = useAppServices();
  const [authSession, loginAsSubAccount] = useAuthInfo();
  const [processing, setProcessing] = useState(true);
  const { companyId } = useParams();
  const [accounts, setAccounts] = useState([]);

  const getData = async () => {
    const { response } = await AppService.account.get({
      query: `company_id=${companyId}`,
    });
    if (response) {
      setAccounts(response.accounts);
      setProcessing(false);
    } else {
      setProcessing(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleAppInstall = () => {
    const url = `https://app.gohighlevel.com/integration/${env.GHL.APP_ID}`;
    window.open(url, "_blank");
  };

  const columns = [
    {
      label: "Name",
      accessor: "name",
      sortable: true,
      renderCell: (row) => (
        <>
          <span className="text-dark fw-semibold">{row.name || "-"}</span>
        </>
      ),
    },
    {
      label: "Actions",
      accessor: "actions",
      renderCell: (row) => (
        <div className="d-flex gap-2 justify-content-center">
          <UpgradeplanModal locationId={row.id} />
          <button
            className="btn btn-primary btn-sm rounded-3 shadow-sm d-flex align-items-center gap-2"
            onClick={() => loginAsSubAccount(row.id, companyId)}
            title="Login as Admin"
          >
            <Icon icon="mdi:account-key-outline" width={18} />
            <span>Login as Admin</span>
          </button>
        </div>
      ),
    },
  ];

  if (processing) {
    return <LoadingScreen loadingText={"Loading accounts..."} />;
  }

  return (
    <div className="min-vh-100" style={{ backgroundColor: "#F5F6FA" }}>
      <div className="container-fluid p-5">
        {/* Header Card */}
        <div
          className="card border-0 shadow-sm mb-4"
          style={{ backgroundColor: "white" }}
        >
          <div className="card-body py-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-1 fw-bold text-dark">Sub Accounts</h4>
                <p className="text-muted mb-0 small">
                  Manage your sub accounts sessions
                </p>
              </div>
              <button
                className="btn btn-primary rounded-3 shadow-sm d-flex align-items-center gap-2"
                onClick={handleAppInstall}
                title="Install App"
              >
                <Icon icon="mdi:download" width={18} />
                <span>Install App</span>
              </button>
            </div>
          </div>
        </div>
        <DataTable columns={columns} data={accounts} entriesPerPage={10} />
      </div>
    </div>
  );
};

export default Accounts;
